export const AGENT_NAME = "shopping_agent";

export const AGENT_API_URL = "/api/agent/";

export const SHOW_SYSTEM_MESSAGES = false;

export const defaultBlue = "#004a77";
export const cloverGreen = "#228800";

export const displayAgentChatList = [
  "3S57JH1B8YF61",
  "CP826PK3AKB55",
  "4V0GFFH1JH5B5",
];

export const chatPAKMSKeys: Record<string, string> = {
  // "12KG2TKXVTWJ5": "6088584814e6a5022c3c7ed5767e88aa",
  "3S57JH1B8YF61": "673df1796c78e4aee0d6dc3d436ed270",
  CP826PK3AKB55: "b1318796917265374beb1322c2af0d88",
  "4V0GFFH1JH5B5": "4b21c1e7a3d313cafca79b5c1fe32edf",
};
